import { ImageField } from '@prismicio/client';
import { OptimizedPrismicImage } from '@/components/index';

import styles from './logo.module.scss';

export const Logo = ({ logo }: { logo: ImageField<never> }) => {
  return (
    <div className={styles.logo_wrapper}>
      <OptimizedPrismicImage field={logo} priority className={styles.logo} />
    </div>
  );
};
